export const resolveError = (error) => {
  console.log("Error Request: ", error.response);

  if (!error.response) {
    return "Serviço indisponível, tente novamente mais tarde!";
  }

  const { status, data } = error.response;

  if (status === 422 && data?.errors && typeof data.errors === 'object') {
    return Object.keys(data.errors)
      .map((key) => {
        let e = Array.isArray(data.errors[key])
          ? data.errors[key].join(", ")
          : data.errors[key];
        return `Campo: ${key} - ${e}`;
      })
      .join(" | ");
  }

  if (status === 400 && Array.isArray(data.errors)) {
    // 🔍 Trata casos como: errors: [ [ "mensagem" ] ]
    if (Array.isArray(data.errors[0])) {
      return data.errors.flat().join(", ");
    }
    return data.errors.join(', ');
  }

  if (status === 403 && data?.errors && typeof data.errors === 'object') {
    return Object.keys(data.errors)
      .map((key) => {
        let e = Array.isArray(data.errors[key])
          ? data.errors[key].join(", ")
          : data.errors[key];
        return `${e}`;
      })
      .join(" | ");
  }

  if (status === 404) {
    return "O Recurso que está tentando acessar não existe";
  }

  if (status === 500) {
    return "Ocorreu um erro interno no servidor!";
  }

  return "Erro inesperado. Tente novamente.";
};
